import React from 'react'
import { Text } from 'react-native'
import type { TextProps } from 'react-native/Libraries/Text/Text'
import { tv } from 'tailwind-variants'

import { caption } from '@ui-kit/core/typography'

const label = tv({
  base: [caption(), 'text-gray-500 line-clamp-1'],
  variants: {
    hasError: {
      true: 'text-error',
    },
    isFocused: {
      true: 'text-deep-forest',
    },
  },
})

interface Props extends Pick<TextProps, 'style' | 'children'> {
  children: React.ReactNode
  className?: string
  hasError?: boolean
  isFocused?: boolean
}

const Label = (props: Props) => (
  <Text
    style={props.style}
    className={label({
      isFocused: props.isFocused,
      hasError: props.hasError,
      className: props.className,
    })}
    ellipsizeMode="tail"
  >
    {props.children}
  </Text>
)

export default Label
